'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/function-bind/index.js
// module id = ../../../../function-bind/index.js
// module chunks = 5